import { Box, Chip, Divider, Typography } from '@mui/material';
import { theme } from 'config/theme';
import { SEARCH } from 'constants/routes';
import { Link } from 'react-router-dom';

type ChipHighlightProps = {
  label: string;
  icon: JSX.Element;
  searchKeywords: string[];
};
function ChipHighlight({ label, icon, searchKeywords }: ChipHighlightProps) {
  return (
    <>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Box sx={{ color: theme.palette.custom.tuna }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ width: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {icon}
          </Box>
          <Typography sx={{ ml: 1, fontWeight: 700 }}>{label}</Typography>
        </Box>
        <Box>
          {searchKeywords?.slice(0, 10).map((keyword, index) => (
            <Link key={keyword} to={`${SEARCH}?q=${keyword}`}>
              <Chip
                key={index}
                label={keyword}
                variant="outlined"
                sx={{
                  mt: 1,
                  mr: 1,
                  cursor: 'pointer',
                  fontSize: 13,
                  fontWeight: 400,
                  '& .MuiChip-label': { padding: '2px 8px' },
                }}
              />
            </Link>
          ))}
        </Box>
      </Box>
    </>
  );
}

export default ChipHighlight;
